import FormController from "./Controllers/FormController";
import ModalController from "./Controllers/ModalController";
import ButtonSectionController from "./Controllers/ButtonSectionController";
import { Password as PasswordInput } from "../../../../components/Inputs";
import { Form, Button } from "antd";
import Popconfirm from "../../../../components/Popconfirm";
import { FormContent } from "../../../../components/Layout/forms";
import {
  MenuSettingsButtonsWrapper,
  MenuSettingsHeader,
  MenuSettingsInfoChoices,
  MenuSettingsSubTitle,
  MenuSettingsTitle,
} from "../../menuSettingsCustom";

const Password = ({ onClose }) => (
  <ModalController onClose={onClose}>
    {({ props, formKey }) => (
      <FormController key={formKey} {...props.formController}>
        {({ formProps }) => (
          <Form {...formProps}>
            <FormContent modal>
              <MenuSettingsHeader>
                <MenuSettingsTitle>Change Password</MenuSettingsTitle>
                <ButtonSectionController {...props.buttonSection}>
                  {({ props, hasChanges }) => (
                    <MenuSettingsButtonsWrapper>
                      <Button
                        id="menuSettingsSave"
                        className="action"
                        type="primary"
                        htmlType="submit"
                        {...props.save}
                      >
                        {hasChanges ? "Save" : "Saved"}
                      </Button>
                      {hasChanges && (
                        <Popconfirm
                          title="Cancel edit"
                          description={
                            <>
                              <p>
                                Possible edits will be lost.
                                <br />
                                Are you sure you want to cancel?
                              </p>
                            </>
                          }
                          okText="Yes"
                          cancelText="No"
                          {...props.popConfirm}
                        >
                          <Button id="menuSettingsCancel" className="action">
                            Cancel
                          </Button>
                        </Popconfirm>
                      )}
                      {!hasChanges && (
                        <Button
                          id="menuSettingsClose"
                          {...props.close}
                          className="action"
                        >
                          Close
                        </Button>
                      )}
                    </MenuSettingsButtonsWrapper>
                  )}
                </ButtonSectionController>
              </MenuSettingsHeader>
              <div>
                <MenuSettingsSubTitle>Change password</MenuSettingsSubTitle>
                <MenuSettingsInfoChoices>
                  <PasswordInput
                    label="Current password"
                    name="current_password"
                  />
                  <PasswordInput name="new_password" label="New password" />
                  <PasswordInput
                    name="confirm_new_password"
                    label="Confirm password"
                  />
                </MenuSettingsInfoChoices>
              </div>
            </FormContent>
          </Form>
        )}
      </FormController>
    )}
  </ModalController>
);

export default Password;
